export interface Assistant {
  id: string;
  channel: AssistantChannel;
  enabled?: boolean;
  name?: string;
  model?: string;
  instructions?: string;
  tools?: AssistantTool[];
  resources?: AssistantResource[];
  vector_store_id?: string;
  metadata?: ChatAssistantMetadata;
}

export interface AssistantTool {
  type: "file_search" | "function";
  name?: string;
  description?: string;
}

export interface AssistantResource {
  id: string;
  name: string;
  created_at: string;
}

export enum AssistantChannel {
  REPLY = "reply",
  CHAT = "chat",
  INSIGHTS = "insights",
  AGENT = "agent",
  UNKNOWN = "unknown",
}

export interface ChatAssistantMetadata {
  displayName: string;
  avatarUrl: string;
  greeting: string;
  initialMessage: string;
  assistantMessageColor: string;
  assistantMessageTextColor: string;
  userMessageColor: string;
  userMessageTextColor: string;
  maxThreadAge: number;
}

export interface Thread {
  threadId: string;
  createdAt: string;
  isFeedbackGiven: boolean;
  hasValidatedEmail: boolean;
}

export interface AssistantChatFeedback {
  id?: number;
  knowledgeBaseId?: number;
  assistantId?: string;
  threadId?: string;
  transcript: {
    text: string;
    timestamp: string;
    sender: "user" | "assistant";
  }[];
  positive: boolean;
  startTime: string;
  endTime: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface FormSubmission {
  id: number;
  knowledgeBaseId: number;
  formId: number;
  data: {
    [key: string]: string | number | boolean;
  };
  createdAt: string;
  updatedAt: string;
}

export interface AssistantChatMessage {
  text: string;
  sender: "user" | "assistant";
  createdAt: number;
}

export interface ProcessedKBData {
  question: string;
  answer: string;
  views: number;
  upvotes: number;
  downvotes: number;
}

export interface JSONValue {
  [key: string]: any;
}
